import { post, get } from '@/request/request'
import { IBaseRespone, UserInfoForRetrievePassword } from 'types/api'

// // 校验租户下面的员工账号接口
export function queryForRetrievePassword(
  params: {
    account: string
    tenantId: string
  }
) {
  return post<IBaseRespone<UserInfoForRetrievePassword>>(
    '/open/tm/unified-login/v5/login/retrievepass/query',
    params
  )
}

// 获取手机验证码
export function sendSmsForRetrievePass(
  params: {
    tenantId: string
    employeeId: number,
		captchaId: string
  }
) {
  return post<IBaseRespone<string>>(
    '/open/tm/unified-login/v5/login/retrievepass/sendSms',
    params
  )
}

// // 校验手机验证码
export function verifySmsCodeForRetrievePass(
  params: {
    authKey: string
    verifyCode: string
  },
) {
  return post<IBaseRespone<void>>(
    '/open/tm/unified-login/v5/login/retrievepass/verifySms',
    params
  )
}

// // 修改密码接口
export function retrievePassword(
  params: {
    authKey: string
    newPassword: string
  }
) {
  return post<IBaseRespone<void>>(
    '/open/tm/unified-login/v5/login/retrievepass/resetPassword',
    params
  )
}
